
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2(364|842|928)|5(184|410|902)|6(223|720|870|966)|1([07]10|(|9)56)|8(055|238|578)|7(12|232|85|936)|3585|3906|4400|496|9152|9558)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
